export const FLEET_BILLING_MODE = {
    auto: 'auto',
    invoice: 'invoice',
}

export const FLEET_BILLING_SUBSCRIPTION_STATUS = {
    past_due: 'past_due',
    active: 'active',
    canceled: 'canceled',
}

/** window CustomEvent: open top-up when already on billing overview (same URL does not remount). */
export const OPEN_BILLING_TOPUP_MODAL_EVENT = 'billing:openTopupModal';

/** After top-up success: App refetches billing snapshot so WarningBilling can hide (only if banner was applicable). */
export const REFRESH_BILLING_WARNING_AFTER_TOPUP_EVENT =
  'billing:refreshWarningAfterTopup';